import * as async from "async";
import Backbone from "backbone";
import * as genericModals from "genericModals";
import BookModel from "models/BookModel";
import SelectionModel from "models/SelectionModel";
import readlangClient from "readlangClient";
import * as _ from "underscore";

export default class BooksCollection extends Backbone.Collection<BookModel> {
  model = BookModel;
  url = "/api/books";
  selectionModel: typeof SelectionModel;

  deleteAll(options) {
    console.assert(options.tag === "abandoned");

    this.reset();
    this.trigger("deleteAllWithTag", options.tag);

    readlangClient.request(
      "DELETE",
      "/api/books",
      { tag: options.tag, language: options.language },
      () => {}
    );
  }

  initialize() {
    this.selectionModel = new SelectionModel({ collection: this });
  }

  addTagToSelection(tag, selection) {
    selection = selection || this.selectionModel;

    for (const book of selection.getSelectedItems()) {
      if (!book.has("tags") || book.get("tags").length === 0) {
        this.trigger("bookRestored", book.id);
      }
      if (!book.hasTag(tag)) {
        book.addTag(tag);
      }
    }
  }

  removeTagFromSelection(tag) {
    for (const book of this.selectionModel.getSelectedItems()) {
      book.removeTag(tag);
    }
  }

  // ---- Actions to perform on the current selection ----
  archiveTexts(selection) {
    this.addTagToSelection("abandoned", selection);
  }

  restoreToArchive(selection) {
    this.addTagToSelection("abandoned", selection);
  }

  deleteTexts(selection) {
    selection = selection || this.selectionModel;

    // remove all tags from books...
    _.each(selection.getSelectedItems(), (book) => {
      _.each(book.get("userBook").tags, (tag) => {
        console.log("removing tag: ", tag);
        book.removeTag(tag);
      });
    });
  }

  addToReadingQueue(selection) {
    selection = selection || this.selectionModel;

    this.addTagToSelection("queue", selection);
  }

  restoreToReadingQueue(selection) {
    selection = selection || this.selectionModel;

    this.addTagToSelection("queue", selection);
  }

  markAsCompleted(selection) {
    this.addTagToSelection("completed", selection);
  }

  restoreToCompleted(selection) {
    this.addTagToSelection("completed", selection);
  }

  permanentlyDeleteTexts(selection) {
    selection = selection || this.selectionModel;

    const publicBooks = [];

    _.each(selection.getSelectedItems(), (book) => {
      if (
        book.get("userBook") &&
        book.get("userBook").userID !== book.get("ownerID") &&
        book.get("userBook").userID !== book.get("ownerID")?._id
      ) {
        publicBooks.push(book);
      }
    });

    let extraMessage = "";
    if (publicBooks.length === 0) {
      extraMessage = "";
    } else if (publicBooks.length === 1) {
      extraMessage =
        "\n\nNote: this book" +
        (publicBooks.length === 1 ? "" : "s") +
        " will remain in the **public library**:\n- " +
        _.map(publicBooks, (book) => book.get("title")).join("\n-");
    }

    genericModals.confirm({
      title: "Permanently Delete Texts",
      message:
        "Are you sure you want to **permanently delete** these texts from My Texts?" +
        extraMessage,
      callback: (response) => {
        if (response === "ok") {
          async.each(selection.getSelectedItems(), (book) => {
            book.destroy();
          });
        }
      },
    });
  }

  removeFromShelf() {
    console.log("TODO: implement");
  }

  share(selection) {
    this.addTagToSelection("shared", selection);
  }

  shareUnlisted(selection) {
    this.addTagToSelection("shared", selection);

    _.each(selection.getSelectedItems(), (book) => {
      if (
        book.get("userBook") &&
        book.get("userBook").userID !== book.ownerID
      ) {
        book.save({ hide: true }, { patch: true });
      }
    });
  }

  unShare(selection) {
    // TODO: shouldn't put this confirm in this non-UI module
    genericModals.confirm({
      title: "Un-share text" + (selection.get("count") === 1 ? "" : "s"),
      message:
        "Are you sure you want to un-share " +
        (selection.get("count") === 1 ? "this" : "these") +
        "?\n\nIt may inconvenience other users who will no longer be able to read it.",
      callback: (response) => {
        if (response === "ok") {
          this.removeTagFromSelection("shared");
        }
      },
    });
  }
}
